import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "@/router/route";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import i18n from "@/i18n";
import "@/global.scss";
import useClickOutside from "@/hooks/useClickOutside";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { customTitle } from "@cs/Directive/title/V-Title";
//@ts-ignore
import stripePlugin from "@/libs/stripe.js";
import * as labelName from "@/libs/labelName";

// 使用插件
dayjs.extend(utc);
dayjs.extend(timezone);

const sw = new URL("/public/sw.js", import.meta.url).href;
const app = createApp(App);
const pinia = createPinia();

// 注册全局方法
Object.entries(labelName).forEach(([name, method]) => {
  app.config.globalProperties[`$${name}`] = method;
});

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

window.addEventListener("load", () => {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker
      .register(sw)
      .then((registration) => {
        console.log("Service Worker registered with scope:", registration.scope);
      })
      .catch((error) => {
        console.error("Service Worker registration failed:", error);
      });
  }
});

app.config.errorHandler = (err, vm, info) => {
  console.info("Global error handler caught an error:", err);
  console.info("Component instance:", vm);
  console.info("Error info:", info);
};
app.directive("title", customTitle); // 全局注册指令

//@ts-ignore
window.__app__ = {
  lockRequest: false
};
//app.directive("tips", createDirectiveTips());
app.use(ElementPlus);
app.use(pinia);
app.use(router);
app.use(i18n);
app.use(stripePlugin); // 使用Stripe插件
app.directive("click-outside", useClickOutside.directives.clickOutside);

app.mount("#app");
